exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.living-content .pre>p{max-width:100%;word-break:break-all\n}", ""]);

// exports
